import { useQuery } from "react-query";
import { API_KEY_GET_TRANSLATION } from "../constants";
import { getTranslation } from "../api";

export const useGetTranslation = (id) => {
  return useQuery([API_KEY_GET_TRANSLATION, id], () => getTranslation(id));
};
